import React from 'react'
import Grid from '@material-ui/core/Grid'
import Box from '@src/components/Box'
import { FormattedMessage } from 'react-intl'
import Link from '@material-ui/core/Link'
import messages from '../messages'
import { OrderItemScheduleLineFragment } from '@src/queries/OrderDetailsQuery.generated'

interface OrderDetailItemsTrackingChinaProps {
  line: OrderItemScheduleLineFragment
  setTrackingInfo: React.Dispatch<
    React.SetStateAction<{ trackingNumber: string; trackingUrl: string } | null>
  >
  excludeLabel?: boolean
  excludeDeliveryId?: boolean
}

const OrderDetailItemsTrackingChina: React.FC<
  OrderDetailItemsTrackingChinaProps
> = ({ line, setTrackingInfo, excludeLabel, excludeDeliveryId }) => {
  if (!line.trackingInfo.length && !line.deliveryId) {
    return <Grid item />
  }
  return (
    <Grid item>
      {!excludeLabel && (
        <Box fontWeight="fontWeightBold">
          <FormattedMessage {...messages.TRACKING} />:
        </Box>
      )}

      {line.trackingInfo.length ? (
        line.trackingInfo.map((tracking) => (
          <Link
            component="button"
            key={tracking.trackingNumber}
            onClick={() =>
              setTrackingInfo({
                trackingNumber: tracking.trackingNumber,
                trackingUrl: tracking.trackingUrl,
              })
            }
            color="secondary"
          >
            <Box fontWeight="fontWeightMedium">{tracking.trackingNumber}</Box>
          </Link>
        ))
      ) : (
        <div>
          <FormattedMessage {...messages.UPDATE_PENDING} />
        </div>
      )}
      {/*deliveryId*/}
      {!excludeDeliveryId && (
        <Box mt={4}>
          <Box fontWeight="fontWeightBold">
            <FormattedMessage {...messages.DELIVERY} />:
          </Box>
          {line.deliveryId ? (
            <div>{line.deliveryId}</div>
          ) : (
            <div>
              <FormattedMessage {...messages.UPDATE_PENDING} />
            </div>
          )}
        </Box>
      )}
    </Grid>
  )
}

export default OrderDetailItemsTrackingChina
